import PricingCardsComponent from '@components/global/PricingCards'

interface Props {
	slice: any
}

export default function PricingCards({ slice }: Props) {
	return (
		<PricingCardsComponent
			display={slice.primary.selling_plans}
			sectionTitle={slice.primary.section_title}
		/>
	)
}
